import React from 'react';
import { motion } from 'framer-motion';
import Hero from "./Sections/Hero";
import About from './Sections/About';
import Project from './Sections/Project';
import Contact from './Sections/Contact';




const Portfolio = () => {
  return (
    <div>
      <Hero /> 
      <About />
      <Project />
      <Contact />
    </div> 
  );
};

export default Portfolio;
